export const config = {
    baseUrl: import.meta.env.VITE_APP_URL,
    PwrUser: null,
    UserID: null,
    User: null,
    UserLVL: null,
    FullUser: null,
}